module.exports = __webpack_public_path__ + "static/media/endpoint-logo.57fae4c2.png";